import API from '../../api/api';
import { toast } from 'sonner';
import {
  GET_PUBS,
  GET_PUB,
  PUBS_LOADING,
  PUBS_ERROR,
  UPDATE_PUB
  
} from './types';
import { getDataFromFile, saveDataToFile } from '../../actions/local/DataLocal';
import { localStorageKeys } from '../../config/localvalue';

// Action pour récupérer tous les clients
export const getPublications = (filters = {}) => async (dispatch) => {
  dispatch({ type: PUBS_LOADING });

  const publications = getDataFromFile(localStorageKeys.publicationsData) || [];
  dispatch({ type: GET_PUBS, payload: publications });
  
  try {
    const params = new URLSearchParams();
    
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.activeOnly) params.append('activeOnly', filters.activeOnly);
    if (filters.status) params.append('status', filters.status);
    if (filters.type) params.append('type', filters.type);

    
    
    const queryString = params.toString();
    const url = `/publications/get_publications${queryString ? '?' + queryString : ''}`;
    
    const res = await API.get(url);
    dispatch({
      type: GET_PUBS,
      payload: res.data.data
    });
    saveDataToFile( res.data.data, localStorageKeys.publicationsData)
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.message 
      ? error.response.data.message 
      : 'Erreur lors de la récupération des publications';
    // toast.error(errorMsg);
    dispatch({
      type: PUBS_ERROR,
      payload: errorMsg
    });
    
    //throw error;
  }
};

// Action pour récupérer un client par son ID
export const getPublicationById = (publicationId) => async (dispatch) => {
  dispatch({ type: PUBS_LOADING });
  
  try {
    const res = await API.get(`/publications/get_publication/${publicationId}`);
    dispatch({
      type: GET_PUB,
      payload: res.data.data
    });
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.message
      ? error.response.data.message
      : 'Erreur lors de la récupération de la publicité';
    
    // toast.error(errorMsg);
    
    dispatch({
      type: PUBS_ERROR,
      payload: errorMsg
    });
    
    //throw error;
  }
};



// Action pour créer une nouvelle publication
export const createPublication = (publicationData) => async (dispatch) => {
  dispatch({ type: PUBS_LOADING });
  
  try {
    const res = await API.post(`/publications/create_publication`, publicationData);

    
    dispatch({
      type: UPDATE_PUB,
      payload: res.data.data
    });
    toast.success(res.data.message || 'Publicité créée avec succès!');
    dispatch(getPublications());
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.message
      ? error.response.data.message
      : 'Erreur lors de la création de la publicité';
    
    toast.error(errorMsg);
    
    dispatch({
      type: PUBS_ERROR,
      payload: errorMsg
    });
    dispatch(getPublications());
    
    //throw error;
  }
};



// Action pour mettre à jour le  du publication
export const updatePublication = (id, publicationData) => async (dispatch) => {
  dispatch({ type: PUBS_LOADING });
  
  try {
    const res = await API.put(`/publications/update_publication/${id}`, publicationData);
    
    
    dispatch({
      type: UPDATE_PUB,
      payload: res.data.data
    });
    toast.success(res.data.message || 'Publicité mise à jour avec succès!');
    dispatch(getPublications());
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.message
      ? error.response.data.message
      : 'Erreur lors de la mise à jour de la publicité';
    
    toast.error(errorMsg);
    
    dispatch({
      type: PUBS_ERROR,
      payload: errorMsg
    });
    dispatch(getPublications());
    
    //throw error;
  }
};







// Action pour mettre à jour le  du publication
export const deletePublication = (id, ) => async (dispatch) => {
  dispatch({ type: PUBS_LOADING });
  
  try {
    const res = await API.delete(`/publications/delete_publication/${id}`);
    
    dispatch({
      type: UPDATE_PUB,
      payload: res.data.data
    });
    toast.success(res?.data?.message || 'Publicité supprimée avec succès!');
    dispatch(getPublications());
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.message
      ? error.response.data.message
      : 'Erreur lors de la suppression de la publicité';

    toast.error(errorMsg);

    dispatch({
      type: PUBS_ERROR,
      payload: errorMsg
    });
    dispatch(getPublications());

    //throw error;
  }
};
